export class MenuItemBookModel {
  id: number;
  menu_item_id: number;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  show_advanced_options: boolean;
  bookable_in_advance_days: number;
  minimum_time_in_advance_minute: number;
  minimum_time_in_advance_type: string;
  reservation_unit_custom: boolean;
  reservation_custom_unit_name: string;
  response_for_pending_service: string;
  responce_for_confirmed_service: string;
  call_to_action_text: string;
  comments_text: string;

  constructor(id = 0,
              menu_item_id = 0,
              monday = true,
              tuesday = true,
              wednesday = true,
              thursday = true,
              friday = true,
              saturday = true,
              sunday = true,
              show_advanced_options = false,
              bookable_in_advance_days = 0,
              minimum_time_in_advance_minute = 0,
              minimum_time_in_advance_type = '',
              reservation_unit_custom = false,
              reservation_custom_unit_name = '',
              response_for_pending_service = '',
              responce_for_confirmed_service = '',
              call_to_action_text = '',
              comments_text = ''
  ) {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.monday = monday;
    this.tuesday = tuesday;
    this.wednesday = wednesday;
    this.thursday = thursday;
    this.friday = friday;
    this.saturday = saturday;
    this.sunday = sunday;
    this.show_advanced_options = show_advanced_options;
    this.bookable_in_advance_days = bookable_in_advance_days;
    this.minimum_time_in_advance_minute = minimum_time_in_advance_minute;
    this.minimum_time_in_advance_minute = minimum_time_in_advance_minute;
    this.minimum_time_in_advance_type = minimum_time_in_advance_type;
    this.reservation_unit_custom = reservation_unit_custom;
    this.reservation_custom_unit_name = reservation_custom_unit_name;
    this.response_for_pending_service = response_for_pending_service;
    this.responce_for_confirmed_service = responce_for_confirmed_service;
    this.call_to_action_text = call_to_action_text;
    this.comments_text = comments_text;

  }
}
